import React, { useContext, useEffect, useState } from "react";
import ICategory from "../../../models/ICategory";
import "./EcommerceCategorySearchSelection.scss";
import CategoryContext from "../../../contexts/CategoryContext";

type Props = {
    categories: ICategory[];
    setCategory: (category?: ICategory) => void;
};

export const EcommerceCategorySearchSelection: React.FC<Props> = (props) => {
    const categoryContext = useContext(CategoryContext);

    const [showCategories, setShowCategories] = useState(false);
    const [contextCategorySelection, setContextCategorySelection] = useState(categoryContext.category);

    useEffect(() => {
        if (categoryContext.category) {
            let isRootCategory = false;

            for (const category of props.categories) {
                if (category.guid === categoryContext.category.guid) {
                    isRootCategory = true;
                }
            }

            if (!isRootCategory) {
                setContextCategorySelection(categoryContext.category);
            }

            // setSelectedCategory(categoryContext.category);
        } else {
            // setSelectedCategory(props.selectedCategory);
        }
    }, [categoryContext.category]);

    const toggleShowCategories = () => {
        setShowCategories(!showCategories);
    };

    const selectCategory = (category?: ICategory) => {
        // setSelectedCategory(category);
        setShowCategories(false);
        //
        // props.setCategory(category);
        categoryContext.setFn(category);
    };

    return (
        <div className={"EcommerceCategorySearchSelection"}>
            <button className={"btn btm-sm btn-primary dropdown-toggle"} onClick={toggleShowCategories}>
                {categoryContext.category ? categoryContext.category.name : "All"}
            </button>
            <ul className={"dropdown-menu"} style={{ display: showCategories ? "block" : "none" }}>
                {contextCategorySelection ? (
                    <li
                        key={contextCategorySelection.guid}
                        onClick={() => selectCategory(contextCategorySelection)}
                        className={"dropdown-item"}>
                        {contextCategorySelection.name}
                    </li>
                ) : null}
                <li onClick={() => selectCategory()} className={"dropdown-item"}>
                    All
                </li>
                {props.categories
                    .filter((item) => !item.hide_category)
                    .map((category) => {
                        return (
                            <li key={category.guid} onClick={() => selectCategory(category)} className={"dropdown-item"}>
                                {category.name}
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
};
